import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import "./BottomSheet.css";
import { BottomSheetType } from "../../interfaces/bottomSheet/BottomSheet.type";
import useComponentsStore from "../../store/componentsStateStore";

const BottomSheet = ({
  data,
}: {
  data: BottomSheetType;
}) => {
  const [show, setShow] = useState<boolean>(false);
  const { continueDraft } = useComponentsStore();
  const [isLoading, setIsLoading] = useState(false);

  const isArabic = (text: string) => /[\u0600-\u06FF]/.test(text);
  const isRTL = isArabic(data?.title);
  const direction = isArabic(data?.title || "") ? "rtl" : "ltr";
  const textAlign = direction === "rtl" ? "right" : "left";
  const textClass = direction === "rtl" ? "text-rtl" : "text-ltr";

  useEffect(() => {
    if (data?.title?.includes("Unavailable") || data?.title?.includes("غير متوفر")) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [data?.title]);

  const handleClose = () => {
    if (data?.cancellable) {
      setShow(false);
    }
  };

  const onClickHandler = async () => {
    try {
      setIsLoading(true);
      await continueDraft(data?.button?.payload);
      setShow(false);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
      window.scrollTo({
        top: 0,
        behavior: "auto",
      });
    }
  };

  return (
    <div>
      <Modal
        className="bottomSheet"
        show={show}
        onHide={handleClose}
        centered
        style={{ direction }}
        backdrop={data?.cancellable ? true : "static"} // Prevent closing when clicking outside if not cancellable
        keyboard={data?.cancellable} // Disable closing with Esc key if not cancellable
      >
        <Modal.Header   className={`modal-header ${
    data?.cancellable ? "header-cancellable" : "header-non-cancellable"
  }`}>
          {data?.cancellable && (
            <button
              type="button"
              className="custom-close-btn"
              aria-label="Close"
              onClick={handleClose}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                width="16"
                height="16"
                fill="black"
              >
                <path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z" />
              </svg>
            </button>
          )}
          <Modal.Title
            className={`modal-title ${textClass}`}
            style={{ textAlign }}
          >
            {data?.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-body ${textClass}`} style={{ textAlign }}>
          {data?.desc}
        </Modal.Body>
        <Modal.Footer className="modal-footer" style={{ textAlign }}>
          <Button className="yes-button" onClick={onClickHandler}>
            {data?.button?.text}
            <span>
              <svg
                width="20"
                height="14"
                viewBox="0 0 20 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  transform: isRTL ? "rotate(180deg)" : "none",
                  transition: "transform 0.3s ease",
                }}
              >
                <path
                  d="M13 0L11.59 1.41L16.17 6H0V8H16.17L11.58 12.59L13 14L20 7L13 0Z"
                  fill="white"
                />
              </svg>
            </span>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BottomSheet;
